import { Grid2 as Grid, Typography } from '@mui/material';
import { ACCESS_INFO_ACTIONS, ACCESS_INFO_SECTIONS, ProjectTeamForm, TeamShowType } from 'domain/shared/newProject';
import { useCallback } from 'react';
import { useProjectSecurityContext } from 'domain/shared/newProject';
import { CloseFormShowButton, EditFormShowButton, SaveFormShowButton, useFormShowContext } from 'framework/form';
import { useShowContext } from 'framework/show';
import { DashboardItemSectionWrapper } from 'framework/ui/dashboard';

const StaffingTeamList = () => {
  const { data: project } = useShowContext<TeamShowType>();

  const { isEditMode } = useFormShowContext();
  const { isAccessGranted } = useProjectSecurityContext();
  const renderActions = useCallback(() => {
    if (
      isAccessGranted(ACCESS_INFO_SECTIONS.TEAM, ACCESS_INFO_ACTIONS.MANAGE) ||
      (isAccessGranted(ACCESS_INFO_SECTIONS.TEAM, ACCESS_INFO_ACTIONS.MANAGE) && !project.isNeedCreateTeam)
    ) {
      return isEditMode
        ? [<SaveFormShowButton key="save" />, <CloseFormShowButton key="close" />]
        : [<EditFormShowButton key="edit" />];
    }
    return null;
  }, [isAccessGranted, project.isNeedCreateTeam, isEditMode]);

  return (
    <DashboardItemSectionWrapper
      sx={{ '.MuiAccordionSummary-root': { p: 0 } }}
      title={
        <Grid container direction="row" justifyContent="space-between" alignItems="center" width="100%">
          <Grid size={2}>
            <Typography variant="h4" color="primary">
              Team
            </Typography>
          </Grid>

          <Grid size="grow" />

          <Grid size="auto" display="flex" alignItems="center">
            {renderActions()}
          </Grid>
        </Grid>
      }
      defaultExpanded
    >
      <ProjectTeamForm />
    </DashboardItemSectionWrapper>
  );
};
export default StaffingTeamList;
